import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import logo from '../../../assets/images/SMUD_Logo.svg';
import './Header.scss';
import { FormattedMessage } from 'react-intl';

const Header = ({ page, activePage, language, changeLanguage }) => {
  const [collapse, setCollapse] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  const mobile = window.innerWidth < 1068;

  const isHomepage =
    window.location.pathname === '/' || window.location.pathname === null;
  return (
    <div className="Header">
      <div className="container-fluid" style={{ padding: 0 }}>
        <Navbar expand="lg">
          <div
            style={{
              paddingTop: '0.75rem',
              paddingBottom: '0.75rem',
            }}
          >
            <Link to="/" className={isHomepage ? 'active' : ''} tabIndex={0}>
              <img
                src={logo}
                className="homepagelogo"
                alt="{process.env.REACT_APP_FULL_COMPANY_NAME}"
              />
            </Link>
          </div>
          <NavbarToggler onClick={() => setCollapse(!collapse)} />
          <Collapse isOpen={collapse} navbar>
            <Nav navbar>
              {!mobile ? (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret aria-label="Toggle Dropdown">
                    <span className="mobile-header-item">
                      <FormattedMessage
                        id="header.electricVehicles"
                        defaultMessage="Browse EVs"
                        description="Shop Electric Header"
                      />
                    </span>
                  </DropdownToggle>
                  <DropdownMenu
                    style={{ color: '#142C41', backgroundColor: '#ffffff' }}
                  >
                    <DropdownItem>
                      <NavLink
                        title={
                          page === 'vehicles' || page === 'used_vehicles'
                            ? 'Active Page'
                            : null
                        }
                        to="/vehicles"
                      >
                        <span className="mobile-header-item">
                          <FormattedMessage
                            id="header.vehicleCatalog"
                            defaultMessage="EV catalog"
                            description="Vehicles Header"
                          />
                        </span>
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink
                        title={page === 'inventory' ? 'Active Page' : null}
                        to="/inventory"
                      >
                        <span className="mobile-header-item">
                          <FormattedMessage
                            id="header.inventory"
                            defaultMessage="EV inventory browser"
                            description="Inventory Header"
                          />
                        </span>
                      </NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                <>
                  <NavItem>
                    <Link
                      to="/vehicles"
                      className={activePage === 'vehicles' ? 'active' : ''}
                    >
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.vehicleCatalog"
                          defaultMessage="EV catalog"
                          description="Vehicles Header"
                        />
                      </span>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link
                      to="/inventory"
                      className={activePage === 'inventory' ? 'active' : ''}
                    >
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.inventory"
                          defaultMessage="EV inventory browser"
                          description="Inventory Header"
                        />
                      </span>
                    </Link>
                  </NavItem>
                </>
              )}
              <NavItem>
                <Link
                  to="/compare-vehicles"
                  className={activePage === 'compare-vehicles' ? 'active' : ''}
                >
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.compareVehicles"
                      defaultMessage="Compare vehicles"
                      description="Compare Vehicles Header"
                    />
                  </span>
                </Link>
              </NavItem>
              <NavItem>
                <NavLink
                  title={page === 'incentives' ? 'Active Page' : null}
                  to="/incentives"
                >
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.incentives"
                      defaultMessage="Incentives"
                      description="Incentives Header"
                    />
                  </span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  title={page === 'rates' ? 'Active Page' : null}
                  to="/rates"
                >
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.rates"
                      defaultMessage="Compare rates"
                      description="Rates Header"
                    />
                  </span>
                </NavLink>
              </NavItem>
              {!mobile ? (
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret aria-label="Toggle Dropdown">
                    <span>
                      <FormattedMessage
                        id="header.charging"
                        defaultMessage="Charging"
                        description="Charging Header"
                      />
                    </span>
                  </DropdownToggle>
                  <DropdownMenu
                    style={{ color: '#142C41', backgroundColor: '#ffffff' }}
                  >
                    <DropdownItem>
                      <NavLink
                        title={page === 'charging' ? 'Active Page' : null}
                        to="/charging-stations"
                      >
                        <span className="mobile-header-item">
                          <FormattedMessage
                            id="header.chargingStations"
                            defaultMessage="Public charging stations map"
                            description="Charging Stations Header"
                          />
                        </span>
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink
                        title={page === 'home chargers' ? 'Active Page' : null}
                        to="/home-chargers"
                      >
                        <span className="mobile-header-item">
                          <FormattedMessage
                            id="header.homeChargers"
                            defaultMessage="Home charger catalog"
                            description="Home Chargers Header"
                          />
                        </span>
                      </NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                <>
                  <NavItem>
                    <Link
                      to="/charging-stations"
                      className={activePage === 'charging' ? 'active' : ''}
                    >
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.chargingStations"
                          defaultMessage="Public charging stations map"
                          description="Charging Stations Header"
                        />
                      </span>
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link
                      to="/home-chargers"
                      className={activePage === 'home chargers' ? 'active' : ''}
                    >
                      <span className="mobile-header-item">
                        <FormattedMessage
                          id="header.homeChargers"
                          defaultMessage="Home charger catalog"
                          description="Home Chargers Header"
                        />
                      </span>
                    </Link>
                  </NavItem>
                </>
              )}
              <NavItem>
                <Link
                  to="/faq"
                  className={activePage === 'faq' ? 'active' : ''}
                >
                  <span className="mobile-header-item">
                    <FormattedMessage
                      id="header.faq"
                      defaultMessage="FAQs"
                      description="FAQ HEader"
                    />
                  </span>
                </Link>
              </NavItem>
              <li className="language-toggle-container" ref={dropdownRef}>
                <div className="language-toggle" onClick={toggleDropdown}>
                  <span className="selected-language-header">
                    {language === 'EN' ? (
                      <FormattedMessage
                        id="header.english"
                        defaultMessage="English"
                        description="English Language Option"
                      />
                    ) : (
                      <FormattedMessage
                        id="header.spanish"
                        defaultMessage="Spanish"
                        description="Spanish Language Option"
                      />
                    )}
                  </span>
                  <span
                    className={`caret ${
                      dropdownOpen ? 'caret-up' : 'caret-down'
                    }`}
                  />
                </div>
                {dropdownOpen && (
                  <div className="language-dropdown">
                    {language === 'EN' ? (
                      <button
                        className="btn-lang"
                        onClick={() => {
                          changeLanguage('ES');
                          setDropdownOpen(false);
                        }}
                      >
                        <FormattedMessage
                          id="header.spanish"
                          defaultMessage="Spanish"
                          description="Spanish Language Option"
                        />
                      </button>
                    ) : (
                      <button
                        className="btn-lang"
                        onClick={() => {
                          changeLanguage('EN');
                          setDropdownOpen(false);
                        }}
                      >
                        <FormattedMessage
                          id="header.english"
                          defaultMessage="English"
                          description="English Language Option"
                        />
                      </button>
                    )}
                  </div>
                )}
              </li>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;

Header.propTypes = {
  page: PropTypes.string,
};
